@if (show) {
  @for (each of loaderItems(10); track each) {
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{
        height: '1.8rem',
        margin: '0',
        borderRadius: '0',
      }" />
  }
}
